export const ModeEnum = Object.freeze({
  RELIABILITY: 'RELIABILITY',
  QUALITY: 'QUALITY',
  MESH_QUALITY: 'MESH-QUALITY',
  LEFTBEHIND: 'LEFTBEHIND'
});

export const MODES = [ModeEnum.RELIABILITY, ModeEnum.QUALITY, ModeEnum.MESH_QUALITY, ModeEnum.LEFTBEHIND]

export const DATEMODES = {
  WEEK: 0,
  DAY: 1
}
